import React, { useEffect, useRef, useContext, useState } from "react";
import SectionTitle from "../../components/section-title";
import Button from "../../components/button";
import JobForm from "../../components/job-form";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";

const JobApplyContainer = ({ contRef, classOption = "section-pb", data }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div
            className={`banner-section service-section position-relative ${classOption}`}
            ref={contRef}
        >
            <div
                className="container p-3"
                style={{
                    borderTop: "solid darkgray",
                    borderBottom: "solid darkgray",
                }}
            >
                <div className="row mb-n7 align-items-center">
                    <div className="col-md-12 col-xl-12 mb-7 text-center">
                        <div className="col-md-12 mt-5">
                            <h3 className="title">
                                <span className="text-primary">
                                    {data["title"]}
                                </span>
                            </h3>
                        </div>
                        {data["department"] ? (
                            <div className="col-md-12 mt-5">
                                Department:{" "}
                                <span className="text-dark">
                                    <b>{data["department"]}</b>
                                </span>
                            </div>
                        ) : (
                            ""
                        )}
                        {data["location"] ? (
                            <div className="col-md-12 mt-3">
                                Location:{" "}
                                <span className="text-dark">
                                    <b>{data["location"]}</b>
                                </span>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>

                    <div className="m-auto col-md-12 col-xl-6 mb-7">
                        <JobForm></JobForm>
                    </div>
                    <hr></hr>
                    <div className="col-md-12 col-xl-12 mb-7 text-center">
                        <div className="col-md-12">
                            <Button
                                classOption="btn btn-sm btn-primary btn-hover-primary mt-5"
                                text="Other Openings"
                                path="/job-opening"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

JobApplyContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.string,
    data: PropTypes.any,
};

export default JobApplyContainer;
